import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import ReactHtmlParser from 'react-html-parser';

import { Icon, Message, Grid, Header, Image } from 'semantic-ui-react';
import { FormControlLabel } from 'material-ui/Form';
import { Switch } from 'material-ui';

import { CtServiceShareAddUser, CtServiceShareCancelService, CtServiceShareCancelUser } from 'containers';

import * as commonVar from 'libs/commonVar';
import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ServiceShare.css';
const cx = classNames.bind(styles);

class ServiceShare extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { saveStatus, isAuth, shareInfo, myInfo, setLastServiceByAccessTime, handleDismissSaveResult } = this.props;

    let saveResult = null;
    if (saveStatus === 100) {
      // 저장 중
    } else if (saveStatus === 0) {
      // 일반 상태
    } else if (saveStatus === 1) {
      // 저장 성공
      saveResult = (
        <div className={cx('config-row-option-result-side')}>
          {defineMessages(formatMessage({ id: 'ServiceShare_1', defaultMessage: '저장되었습니다' })) + '! '}
          ({common.timeFormatFromUTCEpoch(new Date().getTime() / 1000, 10)})
        </div>
      );
    } else if (saveStatus === 2) {
      // 저장 실패
      saveResult = (
        <div className={cx('config-row-option-result-side')}>
          <Message error onDismiss={handleDismissSaveResult}>
            <Message.Header>
              <Icon name="remove circle" />
              {defineMessages(formatMessage({ id: 'ServiceShare_2', defaultMessage: '저장되지 않음' })) + '!'}
            </Message.Header>
          </Message>
        </div>
      );
    } else {
      // 기타
    }

    const myService = [];
    const otherService = [];
    for (let i = 0, l = shareInfo.length; i < l; i++) {
      const d = shareInfo[i];
      if (myInfo.originalServiceNo === d.serviceNo) {
        // 내 서비스에 접속 가능한 사용자
        if (myInfo.userNo !== d.userNo) {
          myService.push(
            <div key={d.userServiceNo} className={cx('share-content-box')}>
              <Header as="h4">
                <div className={cx('default-image')}></div>
                <Header.Content>
                  {d.userName + ' (' + d.userEmail + ')'}
                  <Header.Subheader>
                    {defineMessages(formatMessage({ id: 'ServiceShare_3', defaultMessage: '등록' })) +
                      ': ' +
                      common.timeFormatFromUTCEpoch(d.regEpoch, 2)}
                  </Header.Subheader>
                </Header.Content>
              </Header>
              <CtServiceShareCancelUser shareInfo={d} />
            </div>
          );
        }
      } else {
        otherService.push(
          <div key={d.userServiceNo} className={cx('share-content-box')}>
            <Header as="h4">
              <div className={cx('default-image')}></div>
              <Header.Content>
                {d.serviceName + ' / ' + d.serviceUserName + ' (' + d.serviceUserEmail + ')'}
                <Header.Subheader>
                  {defineMessages(formatMessage({ id: 'ServiceShare_3', defaultMessage: '등록' })) +
                    ': ' +
                    common.timeFormatFromUTCEpoch(d.regEpoch, 2)}
                </Header.Subheader>
              </Header.Content>
            </Header>
            <CtServiceShareCancelService shareInfo={d} />
          </div>
        );
      }
    }

    return (
      <div className={cx('share-grid-box')}>
        <Grid columns={1}>
          <Grid.Row className={cx('sharing-user')}>
            <Grid.Column>
              <div className={cx('share-title-box')}>
                {/* <Icon.Group size="big">
                  <Icon name="home" />
                  <Icon corner name="arrow left" color="blue" />
                </Icon.Group> */}
                <div className={cx('share-title')}>
                  {defineMessages(
                    formatMessage({ id: 'ServiceShare_4', defaultMessage: '내 서비스 이용이 허가된 타 사용자' })
                  )}
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              {myService.length > 0 ? (
                <div className={cx('shared-users')}>{myService}</div>
              ) : (
                  <Message className={cx('share-init-box')}>
                    <div className={cx('share-content-row')}>
                      <div>
                        <Image src="/img/setting/share-service-01.png" />
                      </div>
                      <div className={cx('share-title-area')}>
                        <Message.Header>
                          {ReactHtmlParser(
                            defineMessages(
                              formatMessage({
                                id: 'ServiceShare_6',
                                defaultMessage: '내 서비스를 공유하여 <br/>타 사용자와 함께 관리할 수 있습니다.'
                              })
                            )
                          )}
                        </Message.Header>
                        <br />
                        {ReactHtmlParser(
                          defineMessages(
                            formatMessage({
                              id: 'ServiceShare_7',
                              defaultMessage:
                                '지금 공유 사용자를 추가해 보세요<br /> 옆자리 동료와 함께 대상자 관리 및 훈련 실시등<br />모든 서비스를 공유할 수 있습니다.'
                            })
                          )
                        )}
                      </div>
                    </div>
                    <div className={cx('share-notice')}>
                      {ReactHtmlParser(
                        defineMessages(
                          formatMessage({
                            id: 'ServiceShare_11',
                            defaultMessage:
                              '※ 공유 사용자는 서비스 가입자와 동일한 권한을 갖습니다.<br />단, 마이페이지의 "내 정보","서비스 공유" 메뉴는 이용할 수 없습니다.'
                          })
                        )
                      )}
                    </div>
                  </Message>
                )}
            </Grid.Column>
          </Grid.Row>
          <CtServiceShareAddUser />
          <Grid.Row className={cx('sharing-user')}>
            <Grid.Column>
              <div className={cx('share-title-box')}>
                {/* <Icon.Group size="big">
                  <Icon name="user" />
                  <Icon corner name="arrow right" color="blue" />
                </Icon.Group> */}
                <div className={cx('share-title')}>
                  {defineMessages(
                    formatMessage({ id: 'ServiceShare_5', defaultMessage: '내가 이용 가능한 타 서비스' })
                  )}
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              {otherService.length > 0 ? (
                <div className={cx('shared-users')}>{otherService}</div>
              ) : (
                  <Message className={cx('share-init-box')}>
                    <div className={cx('share-content-row')}>
                      <div>
                        <Image src="/img/setting/share-service-01.png" />
                      </div>
                      <div className={cx('share-title-area')}>
                        <Message.Header>
                          {ReactHtmlParser(
                            defineMessages(
                              formatMessage({
                                id: 'ServiceShare_9',
                                defaultMessage: '타 사용자의 서비스를<br />본인 서비스처럼 이용할 수 있습니다.'
                              })
                            )
                          )}
                        </Message.Header>
                        <br />
                        {ReactHtmlParser(
                          defineMessages(
                            formatMessage({
                              id: 'ServiceShare_13',
                              defaultMessage:
                                '타 사용자의 서비스를 공유 받으면<br />본인 서비스처럼 모든 기능을 이용할 수 있습니다.'
                            })
                          )
                        )}

                        {/* <div className={cx('explain-icon')}>
                    <Icon className={cx('to-my-home')} name="home" color="blue" />
                    <Icon className={cx('to-my-arrow')} name="long arrow left" color="blue" />
                    <Icon className={cx('to-my-users')} name="users" color="grey" />
                  </div> */}
                      </div>
                    </div>
                    <div className={cx('share-notice')}>
                      {ReactHtmlParser(
                        defineMessages(
                          formatMessage({
                            id: 'ServiceShare_8',
                            defaultMessage:
                              '※ 단, 공유 받은 서비스의 마이페이지 메뉴 중<br /> "내 정보", "서비스 공유" 메뉴는 이용할 수 없습니다.'
                          })
                        )
                      )}
                    </div>
                  </Message>
                )}
            </Grid.Column>
          </Grid.Row>
          {otherService.length > 0 && (
            <FormControlLabel
              className={'last-service-by-access-time'}
              className={cx('input-switch')}
              control={
                <Switch
                  classes={{
                    checked: 'checked'
                  }}
                  className={cx('switch')}
                  onChange={setLastServiceByAccessTime}
                  name="lastServiceByAccessTime"
                  defaultChecked={!!myInfo.lastServiceByAccessTime ? true : false}
                />
              }
              label={defineMessages(
                formatMessage({
                  id: 'ServiceShare_12',
                  defaultMessage: '기본 서비스 설정 - 로그인 시 마지막으로 접속한 서비스 유지'
                })
              )}
            />
          )}
          {otherService.length > 0 && saveResult}
        </Grid>
      </div>
    );
  }
}

ServiceShare.propTypes = {
  shareInfo: PropTypes.array,
  myInfo: PropTypes.object
};
ServiceShare.defaultProps = {
  shareInfo: [],
  myInfo: {}
};

export default injectIntl(ServiceShare);



// WEBPACK FOOTER //
// ./src/script/components/share/ServiceShare.js